<script>
	import queryString from "query-string";
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import SveltyPicker from "svelty-picker";
	import { masterData, trigerBlackoutSearch } from "../../store/store";
	import {
		getSelectedIds,
		initializeDropdownOptions,
		updateDropdownOptions,
	} from "../../utils/misc";
	import {
		carparkStatusOptions,
		carSectionOptions,
		carStatusOptions,
		damageTypeOptionsSelect,
		estateOptions,
		evStatusOptions,
		fmsUserStatusOptions,
		groupStatusOptions,
		jobOptions,
		regionOptions,
		reportSectionOptions,
		reportStatusOptions,
		userStatusOptions,
	} from "../../utils/options";
	import DropdownCheckbox from "../DropdownCheckbox/DropdownCheckbox.svelte";
	import { brand } from "src/brand";

	const query = queryString.parse(window.location.search);

	let initialValues = {
		stationId: query.stationId || "",
		jobType: query.jobType || "",
		region: query.region || "",
		estate: query.estate || "",
		status: query.status || "",
		jobReferenceId: query.jobReferenceId || "",
		code: query.code || "",
		vehicleNumber: query.vehicleNumber || "",
		vehicleNumberVI: query.vehicleNumber || "",
		taskType: query.taskType || "",
		fuelTypeId: query.fuelTypeId || "",
		incompleteReason: query.incompleteReason || "",
		endDateRange: query.endDateRange || null,
		startDateRange: query.startDateRange || null,
		BlackoutStartTime: query.BlackoutStartTime || null,
		BlackoutEndTime: query.BlackoutEndTime || null,
		name: query.name || "",
		mobileNumber: query.mobileNumber || "",
		email: query.email || "",
		description: query.description || "",
		minIncentive: query.minIncentive || "",
		maxIncentive: query.maxIncentive || "",
		PriceGroupId: query.PriceGroupId || "",
		carMake: query.carMake || "",
		carModel: query.carModel || "",
		StatusIds: query.StatusIds || "",
		evStatus: query.evStatus || "",
		carColor: query.carColor || "",
		carparkStatus: query.carparkStatus || "",
		plateNumber: query.plateNumber || "",
		addressQuery: query.addressQuery || "",
		keyword: query.keyword || "",
		CarPlateNumber: query.CarPlateNumber || "",
		carpark: query.carpark || "",
		fuelCompany: query.fuelCompany || "",
		fuelCompanyId: query.fuelCompanyId || "",
		EVCompanyId: query.EVCompanyId || "",
		search: query.search || "",
		reportStatus: query.reportStatus || "",
		reportSection: query.reportSection || "",
		carSection: query.carSection || "",
		damageType: query.damageType || "",
		rejectReason: query.rejectReason || "",
		userMobileNumber: query.userMobileNumber || "",
		carAssetOwnerId: query.carAssetOwnerId || "",
		platform: query.platform || "",
		isActive: query.isActive || "",
		taskCategoryId: query.taskCategoryId || "",
	};
	let formValues = { ...initialValues };

	let startDate;
	let endDate;
	let boStartDate; // blackout start date
	let boEndDate; // blackout end date
	let myDateStart = "";
	let myDateEnd = "";

	export let stationId = false;
	export let jobReferenceId = false;
	export let taskReferenceId = false;
	export let vehicleNumber = false;
	export let vehicleNumberVI = false;
	export let region = false;
	export let estate = false;
	export let jobType = false;
	export let status = false;
	export let incompleteReason = false;
	export let startDateRange = false;
	export let endDateRange = false;
	export let BlackoutStartTime = false;
	export let BlackoutEndTime = false;
	export let name = false;
	export let mobileNumber = false;
	export let email = false;
	export let description = false;
	export let fuelType = false;
	export let taskType = false;
	export let incentive = false;
	export let statusName = false;
	export let userStatus = false;
	export let fmsUserStatus = false;
	export let groupStatus = false;
	export let jobStatus = false;
	export let searchParameter = false;
	export let carStatus = false;
	export let evStatus = false;
	export let priceGroup = false;
	export let carMake = false;
	export let carModel = false;
	export let plateNumber = false;
	export let addressQuery = false;
	export let keyword = false;
	export let reportStatus = false;
	export let reportSection = false;
	export let carSection = false;
	export let damageType = false;
	export let CarPlateNumber = false;
	export let carpark = false;
	export let fuelCompany = false;
	export let fuelCompanyId = false;
	export let EVCompanyId = false;
	export let blackoutSearch = false;
	export let alignItem;
	export let carparkStatus = false;
	export let vehicleColor = false;
	export let rejectReason = false;
	export let userMobileNumber = false;
	export let carAssetOwner = [];
	export let taskCategoryId = [];
	export let isActive = null;
	export let platform = false;

	// for active dropdown for dropdown checkboxes
	let activeDropdownId = null;

	$: carStatusDropdownOptions = initializeDropdownOptions(
		carStatusOptions,
		initialValues.StatusIds
	);

	$: platformDropdownOptions = initializeDropdownOptions(
		brand.platformOptions,
		initialValues.platform
	);

	function handleCarStatusChange({ StatusIds }) {
		carStatusDropdownOptions = updateDropdownOptions(
			carStatusDropdownOptions,
			StatusIds
		);
	}

	function handlePlatformChange({ platform }) {
		platformDropdownOptions = updateDropdownOptions(
			platformDropdownOptions,
			platform
		);
	}

	function handleSubmit() {
		const values = { ...formValues };
		if (startDate) {
			values.startDateRange = startDate;
		} else {
			values.startDateRange = "";
		}

		if (endDate) {
			values.endDateRange = endDate;
		} else {
			values.endDateRange = "";
		}

		let params = {};
		for (let key in values) {
			if (values[key] && values[key] !== "") {
				params[key] = values[key];
			}
		}

		const selectedStatusIds = getSelectedIds(carStatusDropdownOptions);
		if (selectedStatusIds.length > 0) {
			params.StatusIds = selectedStatusIds;
		} else {
			delete params.StatusIds;
		}

		const selectedPlatforms = getSelectedIds(platformDropdownOptions);
		if (selectedPlatforms.length > 0) {
			params.platform = selectedPlatforms;
		} else {
			delete params.platform;
		}

		// build param string
		let paramString = Object.entries(params)
			.flatMap(([k, v]) =>
				Array.isArray(v) ? v.map((val) => [k, val]) : [[k, v]]
			)
			.map(
				([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
			)
			.join("&");

		var newRelativePathQuery = window.location.pathname + "?" + paramString;

		if (blackoutSearch) {
			trigerBlackoutSearch.set(false);
			window.history.replaceState(
				null,
				null,
				window.location.origin + newRelativePathQuery
			);
			trigerBlackoutSearch.set(true);
		} else {
			window.location.replace(
				window.location.origin + newRelativePathQuery
			);
		}
	}
</script>

<form on:submit|preventDefault={handleSubmit} class="w-100">
	<Row className="mx-0">
		<Col xs={9} class="">
			<Row class="gx-2">
				{#if description}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="description"
							placeholder=" Description"
							aria-label="Description"
							bind:value={formValues.description}
						/>
					</Col>
				{/if}

				{#if jobReferenceId}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="jobReferenceId"
							placeholder="Search by Job ID"
							aria-label="Search by Job ID"
							bind:value={formValues.jobReferenceId}
						/>
					</Col>
				{/if}
				{#if taskReferenceId}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="code"
							placeholder=" Task reference ID"
							aria-label="Task reference ID"
							bind:value={formValues.code}
						/>
					</Col>
				{/if}
				{#if vehicleNumberVI}
					<Col xs={12}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="vehicleNumber"
							placeholder="Search by vehicle no."
							aria-label="Search by vehicle no."
							bind:value={formValues.vehicleNumber}
						/>
					</Col>
				{/if}
				{#if vehicleNumber}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="vehicleNumber"
							placeholder="Search by vehicle no."
							aria-label="Search by vehicle no."
							bind:value={formValues.vehicleNumber}
						/>
					</Col>
				{/if}
				{#if rejectReason}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1 pb-2"
							name="rejectReason"
							placeholder="Search by reject reason"
							aria-label="Search by reject reason"
							bind:value={formValues.rejectReason}
						/>
					</Col>
				{/if}
				{#if reportSection}
					<Col xs={6}>
						<label
							for="filter-report-section"
							class="visually-hidden"
							>Filter by report section</label
						>
						<select
							id="filter-report-section"
							name="reportSection"
							class="form-select getgo select my-1"
							bind:value={formValues.reportSection}
						>
							{#each reportSectionOptions as option}
								<option value={option.value}
									>{option.label}</option
								>
							{/each}
						</select>
					</Col>
				{/if}
				{#if carSection}
					<Col xs={6}>
						<label for="filter-car-section" class="visually-hidden"
							>Filter by car section</label
						>
						<select
							id="filter-car-section"
							name="carSection"
							class="form-select getgo select my-1"
							bind:value={formValues.carSection}
						>
							{#each carSectionOptions as option}
								<option value={option.value}
									>{option.label}</option
								>
							{/each}
						</select>
					</Col>
				{/if}
				{#if damageType}
					<Col xs={6}>
						<label for="filter-damage-type" class="visually-hidden"
							>Filter by damage type</label
						>
						<select
							id="filter-damage-type"
							name="damageType"
							class="form-select getgo select my-1"
							bind:value={formValues.damageType}
						>
							{#each damageTypeOptionsSelect as option}
								<option value={option.value}
									>{option.label}</option
								>
							{/each}
						</select>
					</Col>
				{/if}

				{#if plateNumber}
					<Col xs={12}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="plateNumber"
							placeholder="Search by vehicle plate"
							aria-label="Search by vehicle plate"
							bind:value={formValues.plateNumber}
						/>
					</Col>
				{/if}
				{#if addressQuery}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="addressQuery"
							placeholder="Search by address"
							aria-label="Search by address"
							bind:value={formValues.addressQuery}
						/>
					</Col>
				{/if}
				{#if keyword}
					<Col xs={12}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="keyword"
							placeholder="Search by car park ID, name, address, or postal code"
							aria-label="Search by car park ID, name, address, or postal code"
							bind:value={formValues.keyword}
						/>
					</Col>
				{/if}
				{#if CarPlateNumber}
					<Col xs={12}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="CarPlateNumber"
							placeholder="Search by vehicle plate"
							aria-label="Search by vehicle plate"
							bind:value={formValues.CarPlateNumber}
						/>
					</Col>
				{/if}
				{#if carpark}
					<Col xs={6}>
						<label for="filter-carpark" class="visually-hidden"
							>Filter by carpark</label
						>
						<select
							id="filter-carpark"
							name="carpark"
							class="form-select getgo select my-1"
							bind:value={formValues.carpark}
						>
							<option value="">All Carparks</option>
							{#if $masterData}
								{#each $masterData?.carParks as option}
									<option value={option.id.toString()}
										>{option.name}</option
									>
								{/each}
							{/if}
						</select>
					</Col>
				{/if}

				{#if priceGroup}
					<Col xs={6}>
						<label for="filter-price-group" class="visually-hidden"
							>Filter by price group</label
						>
						<select
							id="filter-price-group"
							name="PriceGroupId"
							class="form-select getgo select my-1"
							bind:value={formValues.PriceGroupId}
						>
							<option value="">All Price Group</option>
							{#if $masterData}
								{#each $masterData.priceGroups as { id, name }}
									<option value={id.toString()}>{name}</option
									>
								{/each}
							{/if}
						</select>
					</Col>
				{/if}

				{#if carMake}
					<Col xs={6}>
						<label for="filter-car-make" class="visually-hidden"
							>Filter by vehicle make</label
						>
						<select
							id="filter-car-make"
							name="carMake"
							class="form-select getgo select my-1"
							bind:value={formValues.carMake}
						>
							<option value="">All Vehicle Makes</option>
							{#if $masterData && $masterData.vehicleMakes}
								{#each $masterData.vehicleMakes as option}
									<option value={option.id.toString()}
										>{option.name}</option
									>
								{/each}
							{/if}
						</select>
					</Col>
				{/if}
				{#if carModel}
					<Col xs={6}>
						<label for="filter-car-model" class="visually-hidden"
							>Filter by vehicle model</label
						>
						<select
							id="filter-car-model"
							name="carModel"
							class="form-select getgo select my-1"
							bind:value={formValues.carModel}
						>
							<option value="">All Vehicle Models</option>
							{#if $masterData}
								{#each $masterData.vehicleModels as option}
									<option value={option.id}
										>{option.name}</option
									>
								{/each}
							{/if}
						</select>
					</Col>
				{/if}
				{#if vehicleColor}
					<Col xs={6}>
						<label for="filter-car-color" class="visually-hidden"
							>Filter by vehicle color</label
						>
						<select
							id="filter-car-color"
							name="carColor"
							class="form-select getgo select my-1"
							bind:value={formValues.carColor}
						>
							<option value="">All Vehicle Color</option>
							{#if $masterData}
								{#each $masterData.vehicleColors as option}
									<option value={option.id}
										>{option.name}</option
									>
								{/each}
							{/if}
						</select>
					</Col>
				{/if}
				{#if carStatus}
					<Col xs={6}>
						<DropdownCheckbox
							categoryName="Car Statuses"
							id="StatusIds"
							isOpen={activeDropdownId === "StatusIds"}
							options={carStatusDropdownOptions}
							refetch={handleCarStatusChange}
							toggle={() =>
								(activeDropdownId =
									activeDropdownId === "StatusIds"
										? null
										: "StatusIds")}
						/>
					</Col>
				{/if}

				{#if evStatus}
					<Col xs={6}>
						<label for="filter-ev-status" class="visually-hidden"
							>Filter by EV status</label
						>
						<select
							id="filter-ev-status"
							name="evStatus"
							class="form-select getgo select my-1"
							bind:value={formValues.evStatus}
						>
							{#each evStatusOptions as option}
								<option value={option.value}
									>{option.label}</option
								>
							{/each}
						</select>
					</Col>
				{/if}

				{#if fuelCompany}
					<Col xs={6}>
						<label for="filter-fuel-company" class="visually-hidden"
							>Filter by fuel company</label
						>
						<select
							id="filter-fuel-company"
							name="fuelCompany"
							class="form-select getgo select my-1"
							bind:value={formValues.fuelCompany}
						>
							<option value="">All fuel companies</option>
							{#if $masterData}
								{#each $masterData.fuelCompanies as option}
									<option value={option.id.toString()}
										>{option.name}</option
									>
								{/each}
							{/if}
						</select>
					</Col>
				{/if}

				{#if fuelCompanyId}
					<Col xs={6}>
						<label
							for="filter-fuel-company-id"
							class="visually-hidden"
							>Filter by fuel company</label
						>
						<select
							id="filter-fuel-company-id"
							name="fuelCompanyId"
							class="form-select getgo select my-1"
							bind:value={formValues.fuelCompanyId}
						>
							<option value="">All fuel companies</option>
							{#if $masterData}
								{#each $masterData.fuelCompanies as option}
									<option value={option.id.toString()}
										>{option.name}</option
									>
								{/each}
							{/if}
						</select>
					</Col>
				{/if}

				{#if EVCompanyId}
					<Col xs={6}>
						<label for="filter-ev-company" class="visually-hidden"
							>Filter by EV company</label
						>
						<select
							id="filter-ev-company"
							name="EVCompanyId"
							class="form-select getgo select my-1"
							bind:value={formValues.EVCompanyId}
						>
							<option value="">All EV companies</option>
							{#if $masterData}
								{#each $masterData.cpoProviders as option}
									<option value={option.id.toString()}
										>{option.name}</option
									>
								{/each}
							{/if}
						</select>
					</Col>
				{/if}

				{#if name}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="name"
							placeholder="Search by name"
							aria-label="Search by name"
							bind:value={formValues.name}
						/>
					</Col>
				{/if}
				{#if mobileNumber}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="mobileNumber"
							placeholder="Mobile no. (without country code)"
							aria-label="Mobile no. (without country code)"
							bind:value={formValues.mobileNumber}
						/>
					</Col>
				{/if}
				{#if stationId}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="stationId"
							placeholder="Search by Station ID"
							aria-label="Search by Station ID"
							bind:value={formValues.stationId}
						/>
					</Col>
				{/if}

				{#if region}
					<Col xs={6}>
						<label for="filter-region" class="visually-hidden"
							>Filter by region</label
						>
						<select
							id="filter-region"
							name="region"
							class="form-select getgo select my-1"
							bind:value={formValues.region}
						>
							<option value="">All region</option>
							{#each regionOptions as option}
								<option value={option.label}
									>{option.label}</option
								>
							{/each}
						</select>
					</Col>
				{/if}
				{#if taskType}
					<Col xs={6}>
						<label for="filter-task-type" class="visually-hidden"
							>Filter by task type</label
						>
						<select
							id="filter-task-type"
							name="taskType"
							class="form-select getgo select my-1"
							bind:value={formValues.taskType}
						>
							{#each jobOptions as option}
								<option value={option.value}
									>{option.label}</option
								>
							{/each}
						</select>
					</Col>
				{/if}
				{#if estate}
					<Col xs={6}>
						<label for="filter-estate" class="visually-hidden"
							>Filter by estate</label
						>
						<select
							id="filter-estate"
							name="estate"
							class="form-select getgo select my-1"
							bind:value={formValues.estate}
						>
							{#each estateOptions as option}
								<option value={option.value}
									>{option.label}</option
								>
							{/each}
						</select>
					</Col>
				{/if}
				{#if incompleteReason}
					<Col xs={12}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="incompleteReason"
							placeholder="Search by blocking reason"
							aria-label="Search by blocking reason"
							bind:value={formValues.incompleteReason}
						/>
					</Col>
				{/if}
			</Row>
			<Row class="gx-2">
				{#if jobType}
					<Col xs={6}>
						<label for="filter-job-type" class="visually-hidden"
							>Filter by job type</label
						>
						<select
							id="filter-job-type"
							name="jobType"
							class="form-select getgo select my-1"
							bind:value={formValues.jobType}
						>
							{#each jobOptions as option}
								<option value={option.value}
									>{option.label}</option
								>
							{/each}
						</select>
					</Col>
				{/if}
				{#if email}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="email"
							placeholder="Search by email"
							aria-label="Search by email"
							bind:value={formValues.email}
						/>
					</Col>
				{/if}

				{#if userMobileNumber}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="userMobileNumber"
							placeholder="Mobile no. (without country code)"
							aria-label="Mobile no. (without country code)"
							bind:value={formValues.userMobileNumber}
						/>
					</Col>
				{/if}

				{#if status}
					<Col xs={6}>
						<label for="filter-status" class="visually-hidden"
							>Filter by status</label
						>
						<select
							id="filter-status"
							name="status"
							class="form-select getgo select my-1"
							bind:value={formValues.status}
						>
							{#if fmsUserStatus}
								{#each fmsUserStatusOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							{:else if userStatus}
								{#each userStatusOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							{:else if groupStatus}
								{#each groupStatusOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							{:else if reportStatus}
								{#each reportStatusOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							{/if}
						</select>
					</Col>
				{/if}

				{#if searchParameter}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="search"
							placeholder="Input Name, Email, or Mobile number here"
							aria-label="Input Name, Email, or Mobile number here"
							bind:value={formValues.search}
						/>
					</Col>
				{/if}
				{#if statusName}
					<Col xs={6}>
						<input
							type="text"
							class="form-control getgo input my-1"
							name="name"
							placeholder="Search by name"
							aria-label="Search by name"
							bind:value={formValues.name}
						/>
					</Col>
					<Col xs={6}>
						<label for="filter-status-name" class="visually-hidden"
							>Filter by status</label
						>
						<select
							id="filter-status-name"
							name="status"
							class="form-select getgo select my-1"
							bind:value={formValues.status}
						>
							{#each groupStatusOptions as option}
								<option value={option.value}
									>{option.label}</option
								>
							{/each}
						</select>
					</Col>
				{/if}
				{#if carparkStatus}
					<Col xs={6}>
						<label
							for="filter-carpark-status"
							class="visually-hidden"
							>Filter by carpark status</label
						>
						<select
							id="filter-carpark-status"
							name="carparkStatus"
							class="form-select getgo select my-1"
							bind:value={formValues.carparkStatus}
						>
							{#each carparkStatusOptions as option}
								<option value={option.value}
									>{option.label}</option
								>
							{/each}
						</select>
					</Col>
				{/if}
				{#if BlackoutStartTime}
					<Col xs={6}>
						<SveltyPicker
							inputClasses="form-control getgo input my-1  "
							format="yyyy-mm-dd"
							bind:value={myDateStart}
							placeholder="Blackout start date"
							on:change={(e) => (boStartDate = e.detail)}
						/>
					</Col>
				{/if}

				{#if BlackoutEndTime}
					<Col xs={6}>
						<SveltyPicker
							inputClasses="form-control getgo input my-1 "
							format="yyyy-mm-dd"
							bind:value={myDateEnd}
							placeholder="Blackout end date"
							on:change={(e) => (boEndDate = e.detail)}
						/>
					</Col>
				{/if}

				{#if incentive}
					<Col xs={12} class="d-flex align-items-center ">
						<input
							type="text"
							class="form-control getgo input my-1"
							name="minIncentive"
							bind:value={formValues.minIncentive}
							placeholder="Min incentive"
							aria-label="Min incentive"
						/>
						&nbsp;-&nbsp;
						<input
							type="text"
							class="form-control getgo input my-1"
							name="maxIncentive"
							bind:value={formValues.maxIncentive}
							placeholder="Max incentive"
							aria-label="Max incentive"
						/>
					</Col>
				{/if}
			</Row>
			<Row class="gx-2">
				{#if startDateRange}
					<Col xs={6}>
						<SveltyPicker
							inputClasses="form-control getgo input my-1"
							format="yyyy-mm-dd"
							bind:value={myDateStart}
							placeholder={jobStatus
								? "Created/Assigned At Date After"
								: "Start date range"}
							on:change={(e) =>
								e.detail
									? (startDate = e.detail)
									: (startDate = "")}
						/>
					</Col>
				{/if}
				{#if endDateRange}
					<Col xs={6}>
						<SveltyPicker
							inputClasses="form-control getgo input my-1"
							format="yyyy-mm-dd"
							bind:value={myDateEnd}
							placeholder={jobStatus
								? "Created/Assigned At Date Before"
								: "End date range"}
							on:change={(e) =>
								e.detail
									? (endDate = e.detail)
									: (endDate = "")}
						/>
					</Col>
				{/if}
				{#if carAssetOwner.length > 0}
					<Col xs={6}>
						<label
							for="filter-car-asset-owner"
							class="visually-hidden">Filter by asset owner</label
						>
						<select
							id="filter-car-asset-owner"
							name="carAssetOwnerId"
							class="form-select getgo select my-1"
							bind:value={formValues.carAssetOwnerId}
						>
							<option value="">{"All Asset Owners"}</option>
							{#each carAssetOwner as option}
								<option value={option.id.toString()}
									>{option.name}</option
								>
							{/each}
						</select>
					</Col>
				{/if}
				{#if platform}
					<Col xs={6}>
						<DropdownCheckbox
							categoryName="All Platform"
							id="platform"
							isOpen={activeDropdownId === "platform"}
							options={platformDropdownOptions}
							refetch={handlePlatformChange}
							toggle={() =>
								(activeDropdownId =
									activeDropdownId === "platform"
										? null
										: "platform")}
						/>
					</Col>
				{/if}
				{#if isActive}
					<Col xs={6}>
						<label for="filter-is-active" class="visually-hidden"
							>Filter by active status</label
						>
						<select
							id="filter-is-active"
							name="isActive"
							class="form-select getgo select my-1"
							bind:value={formValues.isActive}
						>
							<option value="">All</option>
							<option value={"1"}>Active</option>
							<option value={"0"}>Inactive</option>
						</select>
					</Col>
				{/if}
				{#if taskCategoryId.length > 0}
					<Col xs={6}>
						<label
							for="filter-task-category"
							class="visually-hidden"
							>Filter by task category</label
						>
						<select
							id="filter-task-category"
							name="taskCategoryId"
							class="form-select getgo select my-1"
							bind:value={formValues.taskCategoryId}
						>
							<option value="">All Task Categories</option>
							{#each taskCategoryId as option}
								<option value={option.value.toString()}
									>{option.label}</option
								>
							{/each}
						</select>
					</Col>
				{/if}
			</Row>
		</Col>

		<Col xs={3} class="d-flex align-self-end my-1 ">
			<Button
				class="themeButton primary"
				type="submit"
				style="z-index: 1000">Search</Button
			>
		</Col>
	</Row>
</form>
